


























import { defineComponent } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';
import { AfterSignStep } from '../../../types/enums/after-sign-step';

export default defineComponent({
  setup() {
    const handleOptionPick = (option: AfterSignStep) => {
      if (option === AfterSignStep.Signup) {
        window.open('https://www.getaccept.com/after-sign', '_blank');
      } else {
        window.open('https://www.getaccept.com/after-sign-feedback', '_blank');
      }
    };

    return {
      AfterSignStep,
      handleOptionPick,
      ButtonType,
    };
  },
});
